import { axiosGet, axiosPost, axiosPostWithFile } from "./apiClient";
const BASE_URL = process.env.REACT_APP_BASE_URL + '/brands';

const getAllBrands = async ({ limit = 15, page = 0, status = null, sortModel = [], filterModel = [] }) => {
    try {
        let sendStatus = status;
        if (sendStatus === 0) {
            sendStatus = null;
        }
        let search = null;
        if (filterModel['quickFilterValues']) {
            search = filterModel['quickFilterValues'].join(" ").trim() || null;
        }

        const response = await axiosGet(`${BASE_URL}/get`, {

            limit,
            page,
            sendStatus,
            search,
            sort: sortModel,

        });
        return response;
    } catch (error) {
        console.error('Error fetching all products:', error);
        throw error;
    }
};
const brandAPI = {
    getAllBrands,
    getBrandById: (id) => axiosGet(`${BASE_URL}/view/${id}`),
    createBrand: (formData) => axiosPostWithFile(`${BASE_URL}/add`, formData),
    updateBrand: (formData) => axiosPostWithFile(`${BASE_URL}/add`, formData),
    updateBrandStatus: (data) => axiosPost(`${BASE_URL}/status`, data),
    getBrandStatusLogs: (params) => axiosGet(`${BASE_URL}/status/log`, params),
};
export default brandAPI;
